import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import statWarsLogo from "../assets/images/StatWars-Logo.png";

const SignIn = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Container component="main" maxWidth="xs">
        <div className={classes.content}>
          <img src={statWarsLogo} alt="logo" className={classes.logo} />
          {children}
        </div>
      </Container>
    </div>
  );
};

export default SignIn;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    height: "100vh",
  },
  content: {
    paddingTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(4),
  },
  logo: {
    width: "180px",
  },
}));
